<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="4" class="p-a-0 m-t-5px">
            <multiselect
              v-model="transportadora"
              :options-limit="300"
              :limit="2"
              :limit-text="limitText"
              :options="optionsTransportadora"
              track-by="value"
              label="label"
              id="transportadora"
              :hide-selected="true"
              placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
              :searchable="true"
              :loading="isLoadingTransportadora"
              @search-change="listaTransportadora"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_ciot"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° Ciot</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_pre_fat"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° Pré Fatura</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_fat"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° Fatura</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_carga"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° carga</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_fiscal"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° NFS</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="tp_ciot"
              :options="tpFornecedorOptions"
              track-by="value"
              label="label"
              placeholder="Tipo de CIOT"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              :hide-selected="true"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="status_ciot"
              :options="statusCiotOptions"
              track-by="value"
              label="label"
              placeholder="Status do CIOT"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              :hide-selected="true"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="3" class="p-a-0 m-t-5px">
            <multiselect
              v-model="unidade"
              :options="this.$parent.optionsUnidade"
              track-by="value"
              label="label"
              placeholder="Unidade"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              :hide-selected="true"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import moment from "moment";

import { formatCNPJFromParts } from "../utils";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      helpForm: new Form({
        params: [],
        search: "",
      }),
      isLoadingTransportadora: false,
      transportadora: [],
      optionsTransportadora: [],
      statusCiotOptions: [ {label: 'Aberto', value: 1}, {label: 'Encerrado', value: 2}], 
      tpFornecedorOptions: [ {label: 'Padrão', value: 1}, {label: 'Agregado', value: 2}], 
      num_ciot: "",
      num_pre_fat: "",
      status_ciot: "",
      unidade: "",
      num_fat: "",
      num_carga: "",
      num_fiscal: "",
      tp_ciot: "",
      data_filter: [],
    };
  },
  mounted() {
    this.$events.$on("load-json", (e) => this.carregaJson());
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.data_filter = {
        num_ciot: this.num_ciot,
        unidade: this.unidade,
        num_pre_fat: this.num_pre_fat,
        num_fat: this.num_fat,
        num_carga: this.num_carga,
        num_fiscal: this.num_fiscal,
        status_ciot: this.status_ciot,
        transportadora: this.transportadora,
        tp_ciot: this.tp_ciot,
      };
      this.$events.fire("filter-set", this.data_filter);
    },
    resetFilter() {
      (this.num_ciot = ""),
        (this.num_pre_fat = ""),
        (this.num_fat = ""),
        (this.num_carga = ""),
        (this.num_fiscal = "");
      this.tp_ciot = "";
      this.unidade = "";
      this.transportadora = "";
      this.$events.fire("filter-reset");
    },
    listaTransportadora(search) {
      if (search.length >= 3) {
        this.isLoadingTransportadora = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/transportadora")
          .then((response) => {
            this.optionsTransportadora = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsTransportadora.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ).replace(
                      /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
                      "$1.$2.$3/$4-$5"
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: this.onFormataCnpj(
                    obj.cnpj_base,
                    obj.cnpj_filial,
                    obj.cnpj_digito
                  ),
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.cpf,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.cuit,
                });
              });
            }
            this.isLoadingTransportadora = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>